(function () {
  'use strict';

  const motion = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Add #cuier-buy id to product-information section for anchor scrolling */
  function setupBuySection() {
    const prodInfo = document.querySelector('.product-information');
    if (!prodInfo) return;
    const section = prodInfo.closest('.shopify-section');
    if (section) section.id = 'cuier-buy';
  }

  /* IntersectionObserver reveal for cards, gallery items, trust cards */
  function setupReveal() {
    const els = document.querySelectorAll('[data-cuier-reveal]');
    if (!els.length) return;

    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('is-visible');
            obs.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12 }
    );

    els.forEach((el) => obs.observe(el));
  }

  /* Story block activation — highlight block when centred in viewport */
  function setupStory() {
    const blocks = document.querySelectorAll('.cuier-story__block');
    if (!blocks.length) return;

    blocks[0].classList.add('is-active');

    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            blocks.forEach((b) => b.classList.remove('is-active'));
            e.target.classList.add('is-active');
          }
        });
      },
      { threshold: 0.55, rootMargin: '-15% 0px -15% 0px' }
    );

    blocks.forEach((b) => obs.observe(b));
  }

  /* Smooth scroll for all #cuier-buy anchors */
  function setupSmoothScroll() {
    document.querySelectorAll('a[href="#cuier-buy"]').forEach((a) => {
      a.addEventListener('click', (e) => {
        e.preventDefault();
        const target = document.getElementById('cuier-buy');
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  /* GSAP hero entrance + subtle parallax */
  function initHeroGsap() {
    if (typeof gsap === 'undefined') return;
    gsap.registerPlugin(ScrollTrigger);

    /* Hero text entrance — from() keeps elements visible if GSAP fails */
    const reveals = document.querySelectorAll('.cuier-gsap-reveal');
    if (reveals.length) {
      gsap.from(reveals, {
        y: 36,
        opacity: 0,
        stagger: 0.13,
        duration: 0.95,
        ease: 'power3.out',
        delay: 0.15,
      });
    }

    /* Hero image subtle scale entrance */
    const heroImg = document.querySelector('.cuier-hero__img');
    if (heroImg) {
      gsap.from(heroImg, { scale: 1.06, duration: 1.5, ease: 'power2.out' });
    }

    /* Subtle parallax on hero media */
    const heroMedia = document.querySelector('.cuier-hero__media');
    if (heroMedia) {
      gsap.to(heroMedia, {
        yPercent: 12,
        ease: 'none',
        scrollTrigger: {
          trigger: '.cuier-hero',
          start: 'top top',
          end: 'bottom top',
          scrub: true,
        },
      });
    }
  }

  /* Dynamic GSAP loader — self-hosted în assets/ (URL-uri setate în theme.liquid
     via window.VB_GSAP_SRC); fallback CDN doar dacă asset-urile lipsesc */
  function loadGsap(cb) {
    if (window.gsap) { cb(); return; }
    const src = window.VB_GSAP_SRC || {};
    const s1 = document.createElement('script');
    s1.src = src.core || 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/gsap.min.js';
    s1.onload = () => {
      const s2 = document.createElement('script');
      s2.src = src.st || 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/ScrollTrigger.min.js';
      s2.onload = cb;
      document.head.appendChild(s2);
    };
    document.head.appendChild(s1);
  }

  /* Gallery lightbox carousel */
  function setupGalleryLightbox() {
    const items = document.querySelectorAll('.cuier-gallery__item[data-full]');
    const lb = document.getElementById('cuier-lightbox');
    if (!items.length || !lb) return;

    const imgs = Array.from(items).map((el) => ({
      src: el.dataset.full,
      alt: el.dataset.alt || '',
    }));

    let current = 0;
    const lbImg = document.getElementById('cuier-lb-img');
    const counter = document.getElementById('cuier-lb-counter');

    function show(index) {
      current = (index + imgs.length) % imgs.length;
      lbImg.src = imgs[current].src;
      lbImg.alt = imgs[current].alt;
      counter.textContent = (current + 1) + ' / ' + imgs.length;
    }

    function open(index) {
      show(index);
      lb.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    function close() {
      lb.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    items.forEach((el, i) => el.addEventListener('click', () => open(i)));

    document.getElementById('cuier-lb-close').addEventListener('click', close);
    document.getElementById('cuier-lb-prev').addEventListener('click', () => show(current - 1));
    document.getElementById('cuier-lb-next').addEventListener('click', () => show(current + 1));

    lb.addEventListener('click', (e) => { if (e.target === lb) close(); });

    document.addEventListener('keydown', (e) => {
      if (!lb.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') show(current - 1);
      if (e.key === 'ArrowRight') show(current + 1);
    });

    let touchStartX = 0;
    lb.addEventListener('touchstart', (e) => { touchStartX = e.touches[0].clientX; }, { passive: true });
    lb.addEventListener('touchend', (e) => {
      const dx = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(dx) > 50) dx < 0 ? show(current + 1) : show(current - 1);
    }, { passive: true });
  }

  document.addEventListener('DOMContentLoaded', () => {
    setupBuySection();
    setupReveal();
    setupStory();
    setupSmoothScroll();
    setupGalleryLightbox();
    if (motion) loadGsap(initHeroGsap);
  });
})();
